import * as React from "react";
import EventDetail from "./EventDetail";
import EventDashboard from "./EventDashboard";
import {useEffect, useContext} from "react";
import EventDetailList from "./EventDetailList";
import {useScreen} from "./hooks/useScreen";
import {ScreenContext, withScreenContext} from "./screenContext";
import {useEvents} from "./hooks/useEvent";
import {withEventsContext} from "./eventContext";

const Event = ({eventsList, screenNumberDefault, eventToSee}) => {
    console.log('eventsList', eventsList)
    const {changeScreen} = useScreen();
    const {events} = useEvents(eventsList);
    const {state} = useContext(ScreenContext);

    useEffect(() => {
        if (screenNumberDefault) {
            changeScreen(screenNumberDefault, eventToSee)
        }
    }, []);

    useEffect(() => {
        renderScreen(state.screenNumber)
    }, [state.theEvent]);

    const renderScreen = (number) => {
        switch (number) {
            case 1:
                return <EventDashboard
                            events={events}
                        />
            case 2:
                return <EventDetail/>
            case 3:
                return <EventDetailList
                            events={events.new}
                            title={"Evènement à venir"}
                        />
            case 4:
                return <EventDetailList
                            events={events.old}
                            title={"Evènements passés"}
                        />
            default:
                return <EventDashboard
                            events={events}
                        />
        }
    }
    return (
        renderScreen(state.screenNumber)
    )
}

export default withEventsContext(withScreenContext(Event));
